import { render, staticRenderFns } from "./EdnEditor.vue?vue&type=template&id=63126644&"
import script from "./EdnEditor.vue?vue&type=script&lang=js&"
export * from "./EdnEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports